
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenScope } from './GenScope';
import { GenSyncLocation } from './GenSyncLocation';
import { GenSyncUser } from './GenSyncUser';
import { GenWorkflowStatus } from './GenWorkflowStatus';
import * as moment from 'moment';

export class GenSyncTask {

    archived: boolean;
    contributor: GenSyncUser;
    downloadUrl: string;
    fileLength: number;
    fileType: string;
    location: GenSyncLocation;
    name: string;
    open: boolean;
    originalFilename: string;
    projectSlug: string;
    publishedTimestamp: moment.Moment;
    releaseNotes: string;
    releaseTimestamp: moment.Moment;
    scope: GenScope;
    sha256: string;
    sourceProjectId: number;
    sourceTaskId: number;
    status: GenWorkflowStatus;
    sticky: boolean;
    tags: string[];

    constructor();
    constructor( jsonObj: any );
    constructor( genSyncTask: GenSyncTask);

    constructor( input?: GenSyncTask ) {
        if ( input && typeof input !== 'number' ) {
            this.archived = input.archived; // boolean [boolean]
            if( input.contributor ) {
              this.contributor = new GenSyncUser( input.contributor );
            }
            this.downloadUrl = input.downloadUrl; // string [string]
            this.fileLength = input.fileLength; // int [number]
            this.fileType = input.fileType; // string [string]
            if( input.location ) {
              this.location = new GenSyncLocation( input.location );
            }
            this.name = input.name; // string [string]
            this.open = input.open; // boolean [boolean]
            this.originalFilename = input.originalFilename; // string [string]
            this.projectSlug = input.projectSlug; // string [string]
            if ( input.publishedTimestamp && typeof input.publishedTimestamp === 'string' ) {
                this.publishedTimestamp = moment(input.publishedTimestamp).utc();
            } else {
                this.publishedTimestamp = input.publishedTimestamp;
            }
            this.releaseNotes = input.releaseNotes; // string [string]
            if ( input.releaseTimestamp && typeof input.releaseTimestamp === 'string' ) {
                this.releaseTimestamp = moment(input.releaseTimestamp).utc();
            } else {
                this.releaseTimestamp = input.releaseTimestamp;
            }
            this.scope = (typeof input.scope === 'string') ? GenScope.forName(<string> input.scope) : <any> input.scope; // GenScope
            this.sha256 = input.sha256; // string [string]
            this.sourceProjectId = input.sourceProjectId; // int [number]
            this.sourceTaskId = input.sourceTaskId; // int [number]
            this.status = (typeof input.status === 'string') ? GenWorkflowStatus.forName(<string> input.status) : <any> input.status; // GenWorkflowStatus
            this.sticky = input.sticky; // boolean [boolean]
            this.tags = input.tags; // list [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenSyncTask[] {
        if (arr && arr.map) {
          return arr.map(a => new GenSyncTask(a));
        } else {
          return [];
        }
    }
}

